import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Container, Overline } from "@/components/common";
import { getContentItem } from "@/lib/api";
import { ArrowLeft } from "@phosphor-icons/react";

export default function InsightDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => { setA(null); setNf(false); getContentItem("insights", slug).then(setA).catch(() => setNf(true)); }, [slug]);

  if (nf) return <div className="pt-40 pb-24 text-center"><p className="text-softgrey-600">Article not found.</p><Link to="/insights" className="mt-4 inline-block text-gold-dark">← Back to Insights</Link></div>;
  if (!a) return <div className="pt-40 pb-24 text-center text-softgrey-600">Loading…</div>;

  return (
    <article data-testid="insight-detail-page">
      <section className="relative bg-navy pb-16 pt-36 md:pt-44">
        {a.cover_image && <div className="absolute inset-0"><img src={a.cover_image} alt={a.title} className="h-full w-full object-cover opacity-25" /><div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/85 to-navy/60" /></div>}
        <Container className="relative max-w-3xl">
          <Link to="/insights" className="mb-6 inline-flex items-center gap-1.5 text-sm text-gold"><ArrowLeft size={14} /> Insights</Link>
          <Overline className="text-gold">{a.category}</Overline>
          <h1 className="mt-4 font-serif text-4xl leading-tight tracking-tight text-white md:text-5xl">{a.title}</h1>
          <div className="mt-5 text-sm text-slate-400">{a.author} · {a.reading_time}</div>
        </Container>
      </section>
      <section className="bg-white py-16">
        <Container className="max-w-3xl">
          <div className="space-y-5 text-lg leading-relaxed text-softgrey-600">
            {(a.body || "").split("\n\n").map((p, i) => <p key={i}>{p}</p>)}
          </div>
          <div className="mt-12 rounded-lg border border-slate-200 bg-softgrey-100 p-8">
            <div className="font-serif text-2xl text-navy">Dr. Bhawna Sirohi</div>
            <p className="mt-2 text-sm text-softgrey-600">Medical Oncologist · Researcher · Educator · Cancer Advocate.</p>
            <Link to="/about" className="mt-3 inline-block text-sm font-semibold text-gold-dark">About the author →</Link>
          </div>
        </Container>
      </section>
    </article>
  );
}
